import * as React from 'react';
import CollapsibleCard from '../../../../common/CollapsibleCard';
import FormInput from '../../../../common/form/Input';
import { MasterLockConfiguration, MasterLockIndividualLock, MasterLockPropertyConfiguration, deleteMasterLock } from '../../../../../api/PropertyIntegration';
import Label from 'reactstrap/lib/Label';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import MasterLockRow from './MasterLockRow';
import { MasterLockNewLockInput } from './MasterLockNewLockInput';
import Checkbox from '../../../../common/form/Checkbox';
import { userIsCompanyManageUser, userIsPropertyManageUser, userIsSystemManageUser } from '../../../../../utilities/identity';
import LoadingOverlay from '../../../../common/LoadingOverlay';
import FormValidationDisplay from '../../../../common/form/ValidationDisplay';


interface Props {
    masterLockConfig?: MasterLockConfiguration;
    masterLockPropertyConfig?: MasterLockPropertyConfiguration;
    propertyId: number;
    updateMasterConfig: (config: {
        locks?: MasterLockConfiguration;
        sharing?: MasterLockPropertyConfiguration;
    }) => void;
    updateLocks: (newConfig?: MasterLockConfiguration) => void;
    updateSharing: (newConfig?: MasterLockPropertyConfiguration) => void;
}

const MasterLockConfigurationSection = (props: Props) => {
    const isUser =
    userIsCompanyManageUser() ||
    userIsPropertyManageUser() ||
    userIsSystemManageUser();
   
    const locksFromConfig =
        props.masterLockConfig === undefined || props.masterLockConfig === null || props.masterLockConfig.masterLocks === null || props.masterLockConfig.masterLocks === undefined
            ? ([] as MasterLockIndividualLock[])
            : props.masterLockConfig.masterLocks;
    const [error, setError] = React.useState<string | undefined>();
    const [loading, setLoading] = React.useState(false);
        
            
    const handleDeleteLock = async (deviceIdentifier: string) => {
        setLoading(true);
        let result = await deleteMasterLock(props.propertyId, deviceIdentifier);
        if (result.success) {
                props.updateLocks({
                masterLocks: locksFromConfig.filter(
                    l => l.deviceIdentifier !== deviceIdentifier
                )
            });
        } else {
            setError(result.error);
        }
        setLoading(false);
    };
                
        

    return <CollapsibleCard
                cardTitle="Master Lock Configuration"
                cardOpen={(!!props.masterLockConfig || !!props.masterLockPropertyConfig)}
                onCardOpenChange={open => {
                    if (isUser)  return;
                    const newLocks = open ? { masterLocks: locksFromConfig } : undefined;
                    const newSharing = open ? { sharingCode: '',  notify: false, emailList: '' } : undefined;

                    props.updateMasterConfig({ locks: newLocks, sharing: newSharing});
                }}
            >
                <div>
                    {props.masterLockConfig && (
                        <>
                            {error && <FormValidationDisplay errorMessage={error} />}
                            <LoadingOverlay show={loading} inBootstrapColumn={false} />
                            <FormInput
                                labelProps={{
                                    labelText: 'Sharing Code',
                                    invalidText: 'Please enter sharing code'
                                }}
                                inputProps={{
                                    id: 'masterlock-sharing-code',
                                    name: 'sharingCode',
                                    value: props.masterLockPropertyConfig!.sharingCode,
                                    type: 'string',
                                    required: !props.masterLockPropertyConfig!.sharingCode && locksFromConfig.length ===0,
                                    disabled: isUser
                                }}
                                onChange={(_name, value) =>
                                    !isUser && props.updateSharing({
                                        ...props.masterLockConfig!,
                                        sharingCode: value.toString(),
                                        notify: props.masterLockPropertyConfig!.notify,
                                        emailList: props.masterLockPropertyConfig!.emailList,
                                    })
                                }
                            />
                             <div style={{ display: 'flex', flexDirection: 'row', marginTop: '12px', alignItems: 'center' }}>
                                <Checkbox
                                    toggle={true}
                                    onChange={() => {
                                        props.updateSharing({
                                            ...props.masterLockConfig!,
                                            sharingCode: props.masterLockPropertyConfig!.sharingCode,
                                            notify: !props.masterLockPropertyConfig!.notify,
                                            emailList: props.masterLockPropertyConfig!.emailList
                                        })
                                    }}
                                    inputProps={{
                                        id: `card-open-notify`,
                                        name: `notify`,
                                        checked:  props.masterLockPropertyConfig!.notify,
                                    }}
                                />
                                <span style={{ fontWeight: 'bold', textTransform: 'uppercase', fontSize: '10px', marginLeft: '8px' }}>
                                    send email when keycard/key may not have been returned
                                </span>
                            </div>
                            {
                                props.masterLockPropertyConfig && props.masterLockPropertyConfig!.notify &&
                                <div style={{ marginTop: '8px' }}>
                                    <FormInput
                                        labelProps={{
                                            labelText: 'Emails',
                                            invalidText: 'enter comma seperated emails'
                                        }}
                                        inputProps={{
                                            id: 'masterlock-sharing-emails',
                                            name: 'emails',
                                            value: props.masterLockPropertyConfig!.emailList,
                                            type: 'string',
                                            required: true
                                        }}
                                        onChange={(_name, value) =>
                                            props.updateSharing({
                                                ...props.masterLockConfig!,
                                                sharingCode: props.masterLockPropertyConfig!.sharingCode,
                                                notify: props.masterLockPropertyConfig!.notify,
                                                emailList: value.toString()
                                            })
                                        }
                                    />
                                </div>
                            }
                            <div className='center'>
                                <Label > (or) </Label>
                                <hr className='latch-hr' />
                            </div>
                            {locksFromConfig.length !== 0 && (
                                <Row>
                                    <Col md={3}>
                                        <div>
                                            <b>Lock Name</b>
                                        </div>
                                    </Col>
                                    <Col md={3}>
                                        <div>
                                            <b>Display Name</b>
                                        </div>
                                    </Col>
                                    <Col md={3}>
                                        <div>
                                            <b>Device ID</b>
                                        </div>
                                    </Col>
                                </Row>
                            )}
                             <div className="master-lock-timeslot-warning">
                                <span>
                                    Note: Enabling Master Lock integration eliminates tour timeslots that
                                    don't start at the top of the hour
                                </span>
                            </div>
                            {locksFromConfig.map((l, index) => (
                                <MasterLockRow lockInfo={l} deleteLock={handleDeleteLock} key={index} />
                            ))}
                            <div>
                                <MasterLockNewLockInput
                                    propertyId={props.propertyId}
                                    handleAddLockSuccess={(lockInfo: MasterLockIndividualLock) => {

                                        !isUser && props.updateLocks({
                                            masterLocks: locksFromConfig.concat([lockInfo]),
                                        })
                                        setError("")
                                    }}
                                    setError={(err)=>{
                                        setError(err)
                                    }}
                                    setLoading={(loading)=>{
                                        setLoading(loading)
                                    }}
                                />
                            </div>
                        </>
                    )}
                </div>
        </CollapsibleCard>
};

export default MasterLockConfigurationSection;



// WEBPACK FOOTER //
// ./src/components/pages/admin/editProperty/integrationControls/MasterLockConfigurationSection.tsx